
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1w0sy_103",
  "fit-height": "awsui_fit-height_14iqq_1w0sy_139",
  "with-side-media": "awsui_with-side-media_14iqq_1w0sy_144",
  "variant-default": "awsui_variant-default_14iqq_1w0sy_147",
  "variant-stacked": "awsui_variant-stacked_14iqq_1w0sy_147",
  "refresh": "awsui_refresh_14iqq_1w0sy_155",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_1w0sy_205",
  "with-top-media": "awsui_with-top-media_14iqq_1w0sy_217",
  "content-wrapper": "awsui_content-wrapper_14iqq_1w0sy_222",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_1w0sy_227",
  "media": "awsui_media_14iqq_1w0sy_234",
  "media-top": "awsui_media-top_14iqq_1w0sy_252",
  "media-side": "awsui_media-side_14iqq_1w0sy_257",
  "header": "awsui_header_14iqq_1w0sy_263",
  "header-with-media": "awsui_header-with-media_14iqq_1w0sy_268",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1w0sy_274",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1w0sy_278",
  "header-stuck": "awsui_header-stuck_14iqq_1w0sy_284",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_1w0sy_294",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1w0sy_297",
  "with-paddings": "awsui_with-paddings_14iqq_1w0sy_303",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_1w0sy_312",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1w0sy_370",
  "with-toolbar": "awsui_with-toolbar_14iqq_1w0sy_370",
  "content": "awsui_content_14iqq_1w0sy_222",
  "content-fit-height": "awsui_content-fit-height_14iqq_1w0sy_397",
  "content-with-media": "awsui_content-with-media_14iqq_1w0sy_407",
  "footer": "awsui_footer_14iqq_1w0sy_411",
  "with-divider": "awsui_with-divider_14iqq_1w0sy_415"
};
  